<template>
  <div v-if="!isLoading">
    <!-- Busca e seleção -->
    <div v-if="!associadoVeiculoSelected">
      <!-- Header -->
      <p class="mb-4">Informe a placa ou chassi do veículo</p>

      <vs-card>
        <div>
          <div class="vx-row mt-4">
            <!-- Placa/Chassi -->
            <div class="vx-col lg:w-1/4 w-full mb-2">
              <label for class="vs-input--label">Placa/Chassi</label>
              <vs-switch
                v-model="findPlaca"
                color="success"
                class="mt-2 ml-2"
                @change="updateFindPlaca"
              >
                <span slot="on">Placa</span>
                <span slot="off">Chassi</span>
              </vs-switch>
            </div>

            <!-- Placa -->
            <div class="vx-col lg:w-1/4 w-full mb-2" v-if="showPlaca">
              <vs-input
                class="w-full"
                label="Placa"
                name="Placa"
                v-model="query"
                v-mask="'AAA-#XX#'"
              />
            </div>

            <!-- Chassi -->
            <div class="vx-col lg:w-1/4 w-full mb-2" v-if="!showPlaca">
              <vs-input
                class="w-full"
                label="Chassi"
                name="Chassi"
                v-model="query"
                v-mask="'XXXXXXXXXXXXXXXXX'"
              />
            </div>

            <div class="vx-col lg:w-1/4 w-full flex items-center">
              <vs-button
                color="primary"
                type="filled"
                class="mt-2"
                @click="findAssociado"
                :disabled="!query || query.length < 3"
              >
                Pesquisar
              </vs-button>
            </div>
          </div>
        </div>
      </vs-card>

      <!-- Seleção Associado/Veículo -->
      <div v-if="listResult.length > 0 && !associadoVeiculoSelected">
        <p class="mb-4">Selecione o Benefíciario/Veículo</p>

        <vs-card v-for="item of listResult" :key="item.id_veiculo">
          <div class="vx-row mt-4">
            <!-- Associado -->
            <div class="vx-col lg:w-1/4 w-full">
              <div class="divTitle">
                <span>Benefíciario</span>
              </div>
              <div class="divInfo dados-veiculo">
                <span>
                  {{ item.dadosCliente.nome }}
                </span>
                <span> CPF/CNPJ: {{ item.dadosCliente.cpfcnpj }} </span>
              </div>
            </div>

            <!-- Veículo -->
            <div class="vx-col lg:w-1/2 w-full">
              <div class="divTitle">
                <span>Veículo</span>
              </div>
              <div class="divInfo dados-veiculo">
                <span v-if="item.dadosVeiculo.placa">
                  Placa: {{ item.dadosVeiculo.placa }}
                </span>
                <span> Chassi: {{ item.dadosVeiculo.chassi }} </span>
                <span>
                  Marca/Modelo: {{ item.dadosVeiculo.veiculoMarca }} -
                  {{ item.dadosVeiculo.veiculoModelo }}
                  {{ item.dadosVeiculo.anoFabricacao }}/{{
                    item.dadosVeiculo.anoModelo
                  }}
                </span>
              </div>
            </div>

            <div class="vx-col lg:w-1/4 w-full flex items-center">
              <vs-button
                color="success"
                type="border"
                class="mt-2"
                @click="selectItem(item)"
              >
                Selecionar
              </vs-button>
            </div>
          </div>
        </vs-card>
      </div>

      <!-- Sem resultados -->
      <div v-if="listResult.length == 0 && findCalled">
        <vs-card class="flex justify-center p-4">
          <h5 class="mt-2">Nenhum Benefíciario/Veículo encontrado</h5>
        </vs-card>
      </div>
    </div>

    <!-- Dados Eventos -->
    <div v-else>
      <vs-row class="mb-5">
        <div>
          <vs-button type="flat" @click="clearSelected">
            Realizar nova busca
          </vs-button>
        </div>
      </vs-row>

      <!-- Card's -->
      <vs-row class="mt-5">
        <AssociadoCard :dadosEvento="associadoVeiculoSelected" :width="6" />
        <VeiculoCard :dadosEvento="associadoVeiculoSelected" :width="6" />
      </vs-row>

      <!-- Dados do Evento -->
      <div class="px-4">
        <vs-card>
          <h4 class="mb-3 mt-6">Dados do Evento</h4>

          <div class="vx-row mt-4">
            <!-- Motivo do Evento -->
            <div class="vx-col lg:w-1/2 xl:w-1/3 w-full mb-2">
              <label for="" class="vs-select--label">Motivo do Evento</label>
              <v-select
                :options="listMotivos"
                name="Tipo Evento"
                id="Tipo Evento"
                v-model="formData.idTipoEvento"
                label="label"
                :reduce="(item) => item.id"
              ></v-select>
            </div>

            <!-- Envolvimento -->
            <div class="vx-col lg:w-1/2 xl:w-1/3 w-full mb-2">
              <label for="" class="vs-select--label">Envolvimento</label>
              <v-select
                :options="listEnvolvimentos"
                name="Envolvimento"
                id="Envolvimento"
                v-model="formData.idEnvolvimento"
                label="label"
                :reduce="(item) => item.id"
              ></v-select>
            </div>

            <!-- Data e Hora Evento -->
            <div class="vx-col xl:w-1/3 w-full lg:flex lg:gap-5 mb-2">
              <!-- Data do Evento -->
              <div class="xl:w-1/2 w-full">
                <label class="vs-input--label">Data Evento</label>
                <div class="inputData">
                  <flat-pickr
                    :config="configdateTimePickerDay"
                    v-model="formData.dataEvento"
                    placeholder="DD/MM/AAAA"
                    name="Data do Evento"
                  />
                </div>
              </div>

              <!-- Hora do Evento -->
              <div class="xl:w-1/2 w-full">
                <label class="vs-input--label">Hora Evento</label>
                <div class="inputData">
                  <flat-pickr
                    :config="configdateTimePickerHour"
                    v-model="formData.horaEvento"
                    placeholder="HH:MM"
                    name="Hora do Evento"
                  />
                </div>
              </div>
            </div>
          </div>
        </vs-card>
      </div>

      <vs-row class="mt-5">
        <div class="w-full px-4 text-right">
          <BotaoSubmit
            v-if="$can($actionsDefault.Escrita, 'Eventos')"
            text="Criar Evento"
            :variant="'success'"
            :edit="!loadingButton"
            :aguarde="loadingButton"
            class="ml-4"
            @submit="createEvento"
          ></BotaoSubmit>
        </div>
      </vs-row>
    </div>
  </div>
</template>

<script>
import flatPickr from 'vue-flatpickr-component';
import vSelect from 'vue-select';
import { Portuguese } from 'flatpickr/dist/l10n/pt.js';

import services from '../../../../services';
import notify from '../../../../utils/notify';

import serviceEventos from './../shared/service';
import utilsLocal from './../utils';

import AssociadoCard from './../shared/components/card/AssociadoCard.vue';
import VeiculoCard from './../shared/components/card/VeiculoCard.vue';
import BotaoSubmit from '../../../../components/BotaoSubmit.vue';

export default {
  components: {
    vSelect,
    flatPickr,
    AssociadoCard,
    VeiculoCard,
    BotaoSubmit,
  },
  data() {
    return {
      isLoading: true,
      loadingButton: false,
      findCalled: false,
      findPlaca: true,
      showPlaca: true,
      query: null,
      listResult: [],
      associadoVeiculoSelected: null,

      // Form Data
      formData: {
        idAssociado: null,
        idVeiculo: null,
        idTipoEvento: null,
        idEnvolvimento: null,
        dataEvento: null,
        horaEvento: null,
      },

      // Domínios
      listMotivos: [],
      listEnvolvimentos: [],

      // Configurações de Component
      configdateTimePickerDay: {
        dateFormat: 'd/m/Y',
        locale: Portuguese,
        time_24hr: true,
        disable: [
          function (date) {
            return date > new Date(new Date().setHours(0, 0, 0, 0));
          },
        ],
      },
      configdateTimePickerHour: {
        enableTime: true,
        noCalendar: true,
        dateFormat: 'H:i',
        time_24hr: true,
      },
    };
  },
  methods: {
    async getListDominios() {
      try {
        this.$vs.loading();

        const promises = [
          serviceEventos.getListDominio(
            'domEventosEnvolvimentos',
            'envolvimento',
            'idEnvolvimento',
          ),

          utilsLocal.bucarMotivos(),
        ];

        const [listEnvolvimentos, listMotivos] = await Promise.all(promises);

        this.listEnvolvimentos = listEnvolvimentos;

        listMotivos.forEach((element) => {
          this.listMotivos.push({
            id: element.idMotivo,
            label: element.nomeMotivo,
          });
        });
      } catch (error) {
        console.error(error);
        notify.notifyFail(this.$vs, 'Falha ao carregar os dados do evento');
      } finally {
        this.$vs.loading.close();
        this.isLoading = false;
      }
    },
    updateFindPlaca() {
      this.query = null;
      this.listResult = [];
      this.showPlaca = this.findPlaca;
      this.findCalled = false;
    },
    async findAssociado() {
      if (!this.query) {
        return;
      }

      try {
        this.$vs.loading();

        const { data } = await services.getAll(
          'Eventos2',
          null,
          `novo-evento/dados-associado?q=${this.query}`,
        );

        if (data.length == 1) {
          this.associadoVeiculoSelected = data[0];
          return;
        }

        this.listResult = data;
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      } finally {
        this.findCalled = true;
        this.$vs.loading.close();
      }
    },
    selectItem(value) {
      this.associadoVeiculoSelected = value;
    },
    clearSelected() {
      this.query = null;
      this.listResult = [];
      this.findPlaca = true;
      this.showPlaca = true;
      this.findCalled = false;
      this.associadoVeiculoSelected = null;
    },
    async createEvento() {
      this.formData.idAssociado = this.associadoVeiculoSelected.idAssociado;
      this.formData.idVeiculo = this.associadoVeiculoSelected.idVeiculo;

      try {
        this.$vs.loading();

        const { data } = await services.post(
          'Eventos2',
          'novo-evento',
          this.formData,
        );

        const { idEvento } = data;
        this.$router.replace(`/editar-evento/${idEvento}`);
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      } finally {
        this.$vs.loading.close();
      }
    },
  },
  async mounted() {
    await this.getListDominios();
  },
};
</script>

<style lang="scss" scoped>
.dados-veiculo {
  span {
    display: block;
  }
}
</style>

<style lang="scss">
.vs__dropdown-toggle {
  padding: 4px 0 6px 0 !important;
}

.vdp-datepicker input {
  width: 100%;
}
input.flatpickr-input {
  width: 100%;
}

.table-bordered {
  display: table;
  border-collapse: separate;
  box-sizing: border-box;
  border-spacing: 2px;
  border-color: grey;
  width: 100%;
  tr td {
    padding: 2px;
  }
  tr:nth-child(2n) {
    background: #efefef !important;
  }
}
</style>

<style src="./../../../../assets/css/listCard.css"></style>
